module.exports = __webpack_public_path__ + "static/media/delivery.c1272751.svg";